import React, { useState, useEffect } from "react";
import "../MedicalDetailsPage/MedicalDetails.css";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Skeleton,
  TextField,
} from "@mui/material";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useSelector, useDispatch } from "react-redux";
import { Proposal, ProposerForm } from "../ProposalPage/Proposal";
import { HDFCQuestionAnswer, HDFCPersion } from "../../commonComponents/HDFC";
import { DatePicker } from "@mui/x-date-pickers";
import {
  HDFCQuestionAnswerIndividual,
  HDFCPersionIndividual,
} from "../../commonComponents/HDFCIndividual";
import { useLocation } from "react-router-dom";
import Alert from "@mui/material/Alert";
import { ToastContainer, toast } from "react-toastify";
import {
  ICICIQuestionAnswer,
  ICICIPersion,
} from "../../commonComponents/ICICI";
import {
  findSelf,
  companyId,
  getMonthYear,
  changeDateFormat,
} from "../../helper/common";
import {
  RelianceQuestion,
  ReliancePersion,
} from "../../commonComponents/RelianceQuestion";
import { payload } from "../../helper/godigit";
import Summary from "../../commonComponents/Summary";
import Loader from "../../../AllPageComponents/Loader";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { afterPlanFetchApi, AddonApi } from "../../Api/Api";
import Swal from "sweetalert2";

import { parseData } from "../../helper/common";
import axios from "axios";
import { Card, CardContent, Typography, Grid, Button } from "@mui/material";

import {
  selectProposal,
  updateData,
  addInsuredData,
  updateInsuredData,
  updatecheckedQuestion,
  selectcheckedQuestion,
  updatecheckedPersion,
  selectcheckedPersion,
  updateCareQAlist,
  updateHDFCQAlist,
  updateGodigitQAlist,
} from "../../redux/Slice";
import "../../commonComponents/HDFC.css";
import RelianceQuestionAnswer from "../../commonComponents/RelianceQuestion";
import Redirect from "../../../AllPageComponents/Rederict";
import { Helmet } from "react-helmet-async";
import { getReduxData, settingReduxData } from "../../Api/Api";

const MedicalDetails = () => {
  const history = useNavigate();

  const goBack = () => {
    history(-1);
  };

  const [questionData, setQuestionData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [stopLoading, setStopLoading] = useState(false);

  const [loadingData, setLoadingData] = useState(false);

  const [medErrors, setMedErrors] = useState([]);

  const { userdata, fetchPlandata } = useSelector((state) => {
    return state.FetchPlan;
  });

  //   let insuredData = userdata.InsuredDetail; -----commented out this because not full data of insureddetails is coming here

  // ---------using this proposerData because here the whole data of insureddetails are coming

  // let insuredData = proposerData.InsuredDetail;

  const dispatch = useDispatch();

  const getSelfKey = () => {
    for (let i = 0; i < insuredData.length; i++) {
      if (insuredData[i].InsuredRelation == "Self") {
        return i;
        break;
      }
    }
    return null;
  };

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const unique_id = params.get("req_id");
  let plan_id = params.get("plan_id");
  const c_id = params.get("c_id");
  const company = companyId();

  const [addonArr, setAddonArr] = useState([]);

  const [insuredData, setInsuredData] = useState("");

  // const [loading, setLoading] = useState(true);
  const [apiResponse, setApiResponse] = useState("");
  const [errordata, setErrorData] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [addonDataList, setAddonDataList] = useState([]);

  const [proposerData, setProposerData] = useState();

  const [ICICIcheckedQuestion, setICICICheckedQuestion] = useState({});
  const [ReliancecheckedQuestion, setRelianceCheckedQuestion] = useState({});
  const [HDFCcheckedQuestion, setHDFCcheckedQuestion] = useState({});
  const [careCheckedQuestion, setCareCheckedQuestion] = useState({});
  const [starCheckedQuestion, setStarCheckedQuestion] = useState({});

  const [checkedQuestion, setCheckedQuestion] = useState([]);
  const [checkedPersion, setCheckedPersion] = useState();
  const [finalAddonList, setFinalAddonList] = useState();
  const [extData, setExtData] = useState();

  const [medData, setMedData] = useState();

  // const [userdata , setUserData] = useState('')

  const set_error = (error, message) => {
    setErrorData(error);
    setErrorMessage(message);
  };

  const handleError = (message) => {
    Swal.fire({
      title: "Error!",
      text: message,
      icon: "error",
      confirmButtonText: "OK",
    }).then((result) => {
      if (result.isConfirmed) {
        // Reload the page when user clicks "OK"
        window.location.reload();
      }
    });
    setStopLoading(true);
  };

  const getData = async () => {
    try {
      setStopLoading(true);
      let response = await getReduxData(unique_id).then((response) => {
        setLoadingData(true);

        if (response?.data?.data[0]?.proposal_data) {
          setProposerData(response.data.data[0].proposal_data);
        }
        if (response?.data?.data[0]?.extra_data) {
          setExtData(response.data.data[0].extra_data);
        }

        let medData = response?.data?.data[0]?.medical_question[c_id][plan_id];
        if (medData) {
          setMedData(medData);
        }

        if (
          c_id == "icici" &&
          response?.data?.data[0]?.medical_question[c_id][plan_id]
        ) {
          setICICICheckedQuestion(
            response?.data?.data[0]?.medical_question[c_id][plan_id]
          );
        }

        if (
          c_id == "reliance" &&
          response?.data?.data[0]?.medical_question[c_id][plan_id]
        ) {
          setRelianceCheckedQuestion(
            response?.data?.data[0]?.medical_question[c_id][plan_id]
          );
        }

        if (
          c_id == "hdfc" &&
          response?.data?.data[0]?.medical_question[c_id][plan_id]
        ) {
          setHDFCcheckedQuestion(
            response?.data?.data[0]?.medical_question[c_id][plan_id]
          );
        }

        if (
          c_id == "star" &&
          response?.data?.data[0]?.medical_question[c_id][plan_id]
        ) {
          setStarCheckedQuestion(
            response?.data?.data[0]?.medical_question[c_id][plan_id]
          );
        }

        if (
          c_id == "godigit" &&
          response?.data?.data[0]?.medical_question[c_id][plan_id]
        ) {
          let medicalQuestionsArray =
            response?.data?.data[0]?.medical_question[c_id][plan_id];

          setProposerData((prevState) => {
            const updatedInsuredDetail = prevState.InsuredDetail.map(
              (insured, index) => {
                // Add/update medicalQuestions for each object in InsuredDetail
                if (medicalQuestionsArray[index]) {
                  return {
                    ...insured,
                    medicalQuestions: medicalQuestionsArray[index],
                  };
                }
                return insured; // If no medicalQuestions for this index, return the object as is
              }
            );

            return {
              ...prevState,
              InsuredDetail: updatedInsuredDetail, // Update the InsuredDetail with the modified objects
            };
          });
        }

        if (
          c_id == "care" &&
          response?.data?.data[0]?.medical_question[c_id][plan_id]
        ) {
          let medicalQuestionsArray =
            response?.data?.data[0]?.medical_question[c_id][plan_id];

          setProposerData((prevState) => {
            const updatedInsuredDetail = prevState.InsuredDetail.map(
              (insured, index) => {
                // Add/update medicalQuestions for each object in InsuredDetail
                if (medicalQuestionsArray[index]) {
                  return {
                    ...insured,
                    partyQuestionDOList: medicalQuestionsArray[index],
                  };
                }
                return insured; // If no medicalQuestions for this index, return the object as is
              }
            );

            return {
              ...prevState,
              InsuredDetail: updatedInsuredDetail, // Update the InsuredDetail with the modified objects
            };
          });
        }

        setStopLoading(false);
      });
    } catch (error) {
      console.log("the error", error);
    }
  };

  const settingData = async () => {
    try {
      let phNo = localStorage.getItem("Proposalphonenumber");
      let payloadData;

      if (c_id == "icici") {
        payloadData = {
          medical_question: ICICIcheckedQuestion,
          phone_no: phNo,
          company: c_id,
          plan_code: plan_id,
        };
      } else if (c_id == "godigit") {
        const medicalQuestionsArray = proposerData.InsuredDetail.map(
          (insured) =>
            insured.medicalQuestions && insured.medicalQuestions.length > 0
              ? insured.medicalQuestions
              : []
          // Insert empty object if medicalQuestions is empty or missing
        );

        payloadData = {
          medical_question: medicalQuestionsArray,
          phone_no: phNo,
          company: c_id,
          plan_code: plan_id,
        };
      } else if (c_id == "care") {
        const medicalQuestionsArray = proposerData.InsuredDetail.map(
          (insured) =>
            insured.partyQuestionDOList &&
            insured.partyQuestionDOList.length > 0
              ? insured.partyQuestionDOList
              : [] // Insert empty object if medicalQuestions is empty or missing
        );

        payloadData = {
          medical_question: medicalQuestionsArray,
          phone_no: phNo,
          company: c_id,
          plan_code: plan_id,
        };
      } else if (c_id == "reliance") {
        payloadData = {
          medical_question: ReliancecheckedQuestion,
          phone_no: phNo,
          company: c_id,
          plan_code: plan_id,
        };
      } else if (c_id == "hdfc") {
        payloadData = {
          medical_question: HDFCcheckedQuestion,
          phone_no: phNo,
          company: c_id,
          plan_code: plan_id,
        };
      } else if (c_id == "star") {
        payloadData = {
          medical_question: starCheckedQuestion,
          phone_no: phNo,
          company: c_id,
          plan_code: plan_id,
        };
      }

      let response = await settingReduxData(unique_id, payloadData).then(
        (response) => {}
      );
    } catch (error) {
      console.log("the error", error);
    }
  };

  const fetchPlan = async () => {
    try {
      // Start loading
      const response = await afterPlanFetchApi(unique_id, c_id, plan_id).then(
        (response) => {
          setLoader(false);

          if (response.data.response == null) {
            setStopLoading(true);
            handleError("Oops there is an error !");
          }

          setApiResponse(response.data);
          setFinalAddonList(response.data.request.addonPrice);
          setAddonDataList(response.data.request.addonPrice);

          if (response.data.request.addons) {
            let currentAddons = response.data.request.addons
              ? response.data.request.addons.split(",")
              : [];

            setAddonArr(currentAddons);
          }
        }
      );
    } catch (error) {
      console.log("the error in afterfetchplan", error);
    } finally {
      // setLoading(false); // Stop loading
    }
  };

  const getAddon = async () => {
    try {
      const response = await AddonApi(c_id, plan_id).then((response) => {
        // setAddonList(response.addon_data.data);
        setQuestionData(response.question_answer.data);
      });
    } catch (error) {}
  };

  useEffect(() => {
    getAddon();
    fetchPlan();
    getData();
  }, []);

  function validateFields(answers) {
    let errorsSet = new Set();
    let hasError = false;

    // === CARE product validation ===
    if (c_id === "care") {
      const medicalQuestionsArray = proposerData.InsuredDetail.flatMap(
        (insured) =>
          Array.isArray(insured.partyQuestionDOList)
            ? insured.partyQuestionDOList
            : []
      );

      const selectedQuestions = medicalQuestionsArray.filter(
        (question) => question.response && question.response.trim() !== ""
      );

      // If no question was selected at all, skip validation
      if (selectedQuestions.length === 0) {
        return true;
      }

      // Validate selected questions
      selectedQuestions.forEach((question) => {
        if (!question.response || question.response.trim() === "") {
          errorsSet.add(question.questionCd || question.QuestionId);
          hasError = true;
        }
      });

      setMedErrors(Array.from(errorsSet));

      if (hasError) {
        toast.error("Please complete all required fields.");
      }

      return !hasError;
    }

    // === HDFC product validation ===
    if (c_id === "hdfc") {
      for (let key in answers) {
        const value = answers[key];

        if (Object.keys(value).length === 0) {
          errorsSet.add(key);
          hasError = true;
          continue;
        }

        for (let subKey in value) {
          if (Array.isArray(value[subKey]) && value[subKey].length === 0) {
            errorsSet.add(key);
            hasError = true;
            continue;
          }

          value[subKey].forEach((question) => {
            if (!question.Options) return;

            question.Options.forEach((option) => {
              let isError = false;

              if (plan_id === "Family") {
                if (question.QuestionId == "14") {
                  isError =
                    !option.ExactDiagnosis ||
                    !option.TreatmentDetails ||
                    !option.ConsultationDate ||
                    !option.DiagnosisDate ||
                    !option.CurrentStatus ||
                    !option.LineOfManagement;
                }
                if (question.QuestionId == "15") {
                  isError =
                    !option.ExactDiagnosis ||
                    !option.DiagnosisDate ||
                    !option.CurrentStatus ||
                    !option.SurgeryDate ||
                    !option.SurgeryDetails;
                }
                if (question.QuestionId == "16") {
                  isError =
                    !option.ExactDiagnosis ||
                    !option.DiagnosisDate ||
                    !option.CurrentStatus ||
                    !option.ConsultationDate ||
                    !option.TreatmentDetails;
                }
                if (question.QuestionId == "17") {
                  isError =
                    !option.TestFinding ||
                    !option.TestDate ||
                    !option.TypeOfTest;
                }
                if (question.QuestionId == "18") {
                  isError =
                    !option.ExactDiagnosis ||
                    !option.TreatmentDetails ||
                    !option.ConsultationDate ||
                    !option.DiagnosisDate ||
                    !option.CurrentStatus ||
                    !option.LineOfManagement;
                }
                if (question.QuestionId == "19") {
                  isError = !option.DeliveryDate;
                }
              }

              if (plan_id === "Individual") {
                if (question.QuestionId == "1") {
                  isError =
                    !option.ExactDiagnosis ||
                    !option.TreatmentDetails ||
                    !option.ConsultationDate ||
                    !option.DiagnosisDate ||
                    !option.CurrentStatus ||
                    !option.LineOfManagement;
                }
                if (question.QuestionId == "2") {
                  isError =
                    !option.ExactDiagnosis ||
                    !option.DiagnosisDate ||
                    !option.CurrentStatus ||
                    !option.SurgeryDate ||
                    !option.SurgeryDetails;
                }
                if (question.QuestionId == "3") {
                  isError =
                    !option.ExactDiagnosis ||
                    !option.DiagnosisDate ||
                    !option.CurrentStatus ||
                    !option.ConsultationDate ||
                    !option.TreatmentDetails;
                }
                if (question.QuestionId == "4") {
                  isError =
                    !option.TestFinding ||
                    !option.TestDate ||
                    !option.TypeOfTest;
                }
                if (question.QuestionId == "5") {
                  isError =
                    !option.ExactDiagnosis ||
                    !option.TreatmentDetails ||
                    !option.ConsultationDate ||
                    !option.DiagnosisDate ||
                    !option.CurrentStatus ||
                    !option.LineOfManagement;
                }
                if (question.QuestionId == "6") {
                  isError = !option.DeliveryDate;
                }
              }

              if (isError) {
                errorsSet.add(question.QuestionId);
                hasError = true;
              }
            });
          });
        }
      }

      setMedErrors(Array.from(errorsSet));

      if (hasError) {
        toast.error("Please complete all required fields.");
      }

      return !hasError;
    }

    if (c_id === "star") {
      // Check if criticalIllness key is present at all
      if ("criticalIllness" in answers) {
        toast.error(
          "You are not eligible for this plan due to critical illness."
        );
        return false;
      }

      // Validation for isHealthDiseases continues...
      for (let key in answers) {
        const value = answers[key];

        if (!value || Object.keys(value).length === 0) {
          errorsSet.add(key);
          hasError = true;
          continue;
        }

        for (let subKey in value) {
          const entry = value[subKey];

          if (key !== "isHealthDiseases") continue;

          if (!Array.isArray(entry) || entry.length === 0) {
            errorsSet.add(key);
            hasError = true;
            continue;
          }

          entry.forEach((question) => {
            if (!Array.isArray(question?.Options)) return;

            let hasValidOption = false;

            question.Options.forEach((option) => {
              const {
                OptionId,
                HasCondition = "",
                ExactDiagnosis = "",
              } = option;

              const trimmedHasCondition = HasCondition.trim().toLowerCase();
              const trimmedDiagnosis = ExactDiagnosis.trim();

              if (
                (OptionId === "isDiabetes" || OptionId === "isHypertension") &&
                trimmedHasCondition === "yes"
              ) {
                hasValidOption = true;
              }

              if (OptionId === "illness" && trimmedDiagnosis !== "") {
                hasValidOption = true;
              }
            });

            if (!hasValidOption) {
              errorsSet.add(question.QuestionId);
              hasError = true;
            }
          });
        }
      }

      setMedErrors(Array.from(errorsSet));

      if (hasError) {
        toast.error("Please complete all required fields.");
      }

      return !hasError;
    }

    for (let key in answers) {
      const value = answers[key];

      if (Object.keys(value).length === 0) {
        errorsSet.add(key);
        hasError = true;
        continue;
      }

      for (let subKey in value) {
        if (Array.isArray(value[subKey]) && value[subKey].length === 0) {
          errorsSet.add(key);
          hasError = true;
        }
      }
    }

    setMedErrors(Array.from(errorsSet));

    if (hasError) {
      toast.error("Please complete all required fields.");
    }

    return !hasError;
  }

  function getQuestionData() {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url:
        process.env.REACT_APP_BASE_URL +
        "health/fetch_question/" +
        company[c_id] +
        "/" +
        plan_id,
      headers: {},
      async: false,
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.question_answer.status == true) {
          setQuestionData(response.data.question_answer.data);
          setLoader(false);
        } else {
          setQuestionData([]);
        }
      })
      .catch((error) => {
        setQuestionData([]);
        // console.log(error);
      });
  }

  const medicalQsubmit = (e) => {
    e.preventDefault();

    const diseaseNameValues = Array.from(e.target.elements)
      .filter((element) => element.name === "Disease Name")
      .map((element) => element.value);
    const surgeryDateValues = Array.from(e.target.elements)
      .filter((element) => element.name === "Surgery Date")
      .map((element) => element.value);
    const dateOfDiagnosisValues = Array.from(e.target.elements)
      .filter((element) => element.name === "Date of Diagnosis")
      .map((element) => element.value);
    const lastConsultationDateValues = Array.from(e.target.elements)
      .filter((element) => element.name === "Last Consultation Date")
      .map((element) => element.value);

    const formData = {
      diseaseName: diseaseNameValues,
      surgeryDate: surgeryDateValues,
      dateOfDiagnosis: dateOfDiagnosisValues,
      lastConsultationDate: lastConsultationDateValues,
    };
  };

  useEffect(() => {
    if (apiResponse && apiResponse.response == null) {
      setStopLoading(true);
      handleError("Oops there is an Error");
    }
  }, [apiResponse]);

  useEffect(() => {
    if (medData && questionData && ["godigit", "care"].includes(c_id)) {
      const parsedData = questionData.map((item) => parseData(item));

      const updatedCheckedQuestions = [...checkedQuestion];

      parsedData.forEach((item, index) => {
        medData.forEach((value) => {
          // Add index to updatedCheckedQuestions if not already present

          if (c_id == "godigit" && Array.isArray(value)) {
            value?.map((inval, indexval) => {
              if (item.question_id === inval.questionCode) {
                if (!updatedCheckedQuestions.includes(index)) {
                  updatedCheckedQuestions.push(index);
                }
              }
            });
          }

          if (c_id == "care" && Array.isArray(value)) {
            value?.map((inval, indexval) => {
              if (item.question_id === inval.questionCd) {
                if (!updatedCheckedQuestions.includes(index)) {
                  updatedCheckedQuestions.push(index);
                }
              }
            });
          }
        });
      });

      const stringifiedArray = updatedCheckedQuestions.map((item) =>
        item.toString()
      );

      setCheckedQuestion(stringifiedArray);

      if (c_id == "godigit") {
        const formattedResult = {};

        medData.forEach((personArray, personIndex) => {
          if (Array.isArray(personArray)) {
            personArray.forEach((question) => {
              // let data = questionData.map((val,ind)=>{
              //   if(val.question_id == question){
              //     return ind
              //   }
              // })

              const { questionCode } = question;

              if (!formattedResult[questionCode]) {
                formattedResult[questionCode] = [];
              }

              formattedResult[questionCode].push(personIndex);
            });
          }
        });

        let accData = {};

        parsedData.map((item, index) => {
          const updatedObject = Object.keys(formattedResult).reduce(
            (acc, key) => {
              if (!acc) acc = {}; // Ensure `acc` is initialized properly

              let newKey;
              // Determine the new key based on the condition
              if (item.question_id == key) {
                newKey = index; // Assign the index to newKey
                acc[newKey] = formattedResult[key];
                // accData = acc
                accData[newKey] = formattedResult[key];

                // Assign the value to the new key
              } else {
                acc[key] = formattedResult[key]; // Preserve other keys
              }

              return acc;
            },
            {}
          );

          if (updatedObject) {
            setCheckedPersion(accData); // Perform your state update here
          }
        });
      }

      if (c_id == "care") {
        const formattedResult = {};

        // Iterate over each person (outer array)
        medData.forEach((personArray, personIndex) => {
          if (Array.isArray(personArray)) {
            // Iterate over each question object for the person
            personArray.forEach((question) => {
              // let data = questionData.map((val,ind)=>{
              //   if(val.question_id == question){
              //     return ind
              //   }
              // })

              const { questionCd } = question;

              // Initialize the questionCode key if it doesn't exist
              if (!formattedResult[questionCd]) {
                formattedResult[questionCd] = [];
              }

              // Add the personIndex to the array for that questionCode
              formattedResult[questionCd].push(personIndex);
            });
          }
        });

        let accData = {};

        parsedData.map((item, index) => {
          const updatedObject = Object.keys(formattedResult).reduce(
            (acc, key) => {
              if (!acc) acc = {}; // Ensure `acc` is initialized properly

              let newKey;
              // Determine the new key based on the condition
              if (item.question_id == key) {
                newKey = index; // Assign the index to newKey
                acc[newKey] = formattedResult[key];
                // accData = acc
                accData[newKey] = formattedResult[key];

                // Assign the value to the new key
              } else {
                acc[key] = formattedResult[key]; // Preserve other keys
              }

              return acc; // Always return the accumulator
            },
            {}
          ); // Initial value for `acc` is an empty object

          if (updatedObject) {
            setCheckedPersion(accData); // Perform your state update here
          }
        });
      }
    }
  }, [medData, questionData]);

  // if (!proposerData) {
  //   return (
  //     <div>
  //       <Loader />
  //     </div>
  //   );
  // }

  // if(!proposerData){
  //   return (
  //     <div>
  //       <Loader />
  //     </div>
  //   );
  // }

  useEffect(() => {
    if (proposerData) {
      setLoadingData(true);
    }
  }, [proposerData]);

  const StarQuestionAnswer = ({
    data,
    index,
    insuredData,
    starCheckedQuestion,
    setStarCheckedQuestion,
    medErrors,
    setMedErrors,
  }) => {
    const updateHDFCQuestion = ({ val }) => {
      setStarCheckedQuestion((prevState) => {
        const updatedState = { ...prevState };

        if (updatedState.hasOwnProperty(val)) {
          delete updatedState[val];
        } else {
          updatedState[val] = {};
        }

        return updatedState;
      });
    };

    useEffect(() => {
      if (medErrors.length > 0) {
        const firstErrorElement = document.querySelector(
          `[data-question-id="${medErrors[0]}"]`
        );
        if (firstErrorElement) {
          firstErrorElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }
    }, [medErrors]);

    return (
      <>
        <div
          className="all-que-div col-md-12"
          data-question-id={data.question_id}
        >
          <div
            className={
              medErrors.includes(data.question_id)
                ? "col-md-12 pmd-all med-error-present"
                : "col-md-12 pmd-all med-error-absent"
            }
          >
            <FormControlLabel
              value={data.question_id}
              onChange={(e) => {
                const isChecked = e.target.checked;
                updateHDFCQuestion({ val: e.target.value });

                if (!isChecked) {
                  setMedErrors((prevErrors) =>
                    prevErrors.filter((id) => id !== data.question_id)
                  );
                }
              }}
              control={
                <Checkbox
                  className={
                    medErrors.includes(data.question_id)
                      ? "checkbox-error"
                      : "checkbox-normal"
                  }
                />
              }
              label={"Q. " + data.question}
              checked={starCheckedQuestion.hasOwnProperty(data.question_id)}
              className={
                medErrors.includes(data.question_id)
                  ? "label-error"
                  : "label-normal"
              }
            />
          </div>
        </div>
      </>
    );
  };

  const StarPersion = ({
    data,
    persion,
    pindex,
    proposerData,
    starCheckedQuestion,
    setStarCheckedQuestion,
  }) => {
    const [selectedGender, setSelectedGender] = useState(
      localStorage.getItem("selectedType")
    );

    const updateHDFCPerson = (payload) => {
      const { question_id, pindex } = payload;
      setStarCheckedQuestion((prevState) => {
        const updatedState = { ...prevState };

        if (!updatedState[question_id]) {
          updatedState[question_id] = {};
        }

        const question = updatedState[question_id];

        if (question.hasOwnProperty(pindex)) {
          delete question[pindex];
        } else {
          question[pindex] = [];
        }

        return updatedState;
      });
    };

    const check = () => {
      if (starCheckedQuestion.hasOwnProperty(data.question_id)) {
        if (starCheckedQuestion[data.question_id].hasOwnProperty(pindex)) {
          return true;
        }
      }
      return false;
    };

    useEffect(() => {
      setSelectedGender(localStorage.getItem("selectedType"));
    }, []);

    const allowedRelationsByGender = {
      M: ["Mother", "Grand Mother", "Sister", "Wife", "Mother In Law"],
      F: ["Mother", "Grand Mother", "Sister", "Wife", "Mother In Law", "Self"],
    };

    const allowedRelations = allowedRelationsByGender[selectedGender] || [];
    const personPresent = allowedRelations.includes(persion?.InsuredRelation);

    const getDisplayStyle = () => {
      const search = window.location.search;
      const params = new URLSearchParams(search);
      const plan_id = params.get("plan_id");
      const c_id = params.get("c_id");

      const isQuestion6 = data.question_id == 6;
      const isHDFC = c_id == "hdfc";
      const isFamilyPlan = plan_id == "Family";
      const isIndividualPlan = plan_id == "Individual";

      if (isQuestion6 && isHDFC) {
        if (isFamilyPlan && !personPresent) {
          return "none";
        } else if (isIndividualPlan && !personPresent) {
          return "none";
        }
      }

      return "block";
    };

    return (
      <>
        <div
          className={`same-section-med col-md-6 ${
            data.question_id == 6 &&
            c_id == "hdfc" &&
            plan_id == "Individual" &&
            !personPresent
              ? "hidden-section"
              : "visible-section"
          }`}
        >
          <div
            hidden={!starCheckedQuestion.hasOwnProperty(data.question_id)}
            onClick={(e) => {
              if (
                data.question_id == 6 &&
                c_id == "hdfc" &&
                plan_id == "Individual" &&
                !personPresent
              ) {
                // Prevent the click if condition is met
                e.stopPropagation();
                return;
              } else {
                updateHDFCPerson({
                  pindex: pindex,
                  question_id: data.question_id,
                });
              }
            }}
            className={`clickable-box ${
              data.question_id == 6 &&
              c_id == "hdfc" &&
              plan_id == "Individual" &&
              !personPresent
                ? "disabled-box"
                : ""
            }`}
            style={{
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            <div
              // className={`${
              //   check() ? "sumbox all-med-sum col-md-12" : "sumbox all-med-addon"
              // } sumbox-center`}

              className={
                data.question_id == 6 &&
                c_id == "hdfc" &&
                plan_id == "Individual" &&
                !personPresent
                  ? "sumbox disabled-box"
                  : check()
                  ? "sumbox all-med-sum col-md-12"
                  : "sumbox all-med-addon"
              }
            >
              <div>
                <span className={check() ? "para" : "para-unchecked"}>
                  {proposerData?.InsuredDetail[pindex]?.InsuredName}

                  {data.question_id == 6 &&
                  c_id == "hdfc" &&
                  plan_id == "Individual" &&
                  !personPresent ? (
                    <span>({persion?.InsuredRelation})</span>
                  ) : (
                    <span className={check() ? "para-relation" : "para-rel"}>
                      ({persion?.InsuredRelation})
                    </span>
                  )}

                  {data.question_id == 6 &&
                  c_id == "hdfc" &&
                  plan_id == "Individual" &&
                  !personPresent ? (
                    <span>(Not Applicable)</span>
                  ) : (
                    ""
                  )}
                </span>
              </div>
            </div>
          </div>
          {data?.get_child_question?.map((child_data) => {
            return (
              <SubQuestionAnswer
                key={child_data.question_id}
                data={child_data}
                parentData={data}
                pindex={pindex}
                proposerData={proposerData}
                starCheckedQuestion={starCheckedQuestion}
                setStarCheckedQuestion={setStarCheckedQuestion}
              />
            );
          })}
        </div>
      </>
    );
  };

  function HDFCgetAnswerSet(qdata, name, value, parentQid) {
    if (parentQid == "isHealthDiseases") {
      if (qdata.question_id == "illness") {
        return {
          OptionId: qdata.question_id,
          OptionText: "Yes",
          ExactDiagnosis: name == "ExactDiagnosis" ? value : "",
        };
      }
    } else if (parentQid == "isHealthDiseases") {
      if (qdata.question_id == "isHypertension") {
        return {
          OptionId: qdata.question_id,
          OptionText: "Yes",
          checkboxResponse: name == "checkboxResponse" ? value : "",
        };
      }
    }
  }

  function HDFCquestionExist(qa, qid) {
    for (let i = 0; i < qa.length; i++) {
      if (qa[i].QuestionId == qid) {
        return i;
        break;
      }
    }
    return false;
  }

  const SubQuestionAnswer = ({
    data,
    pindex,
    parentData,
    proposerData,
    starCheckedQuestion,
    setStarCheckedQuestion,
  }) => {
    function updateHDFCQAlist(payload) {
      const { parentqData, pindex, qdata, name, value } = payload;
      const parentQid = parentqData.question_id;

      setStarCheckedQuestion((prev) => {
        const newState = JSON.parse(JSON.stringify(prev)); // deep clone

        if (!newState[parentQid]) newState[parentQid] = {};
        if (!newState[parentQid][pindex]) newState[parentQid][pindex] = [];

        const qaArray = newState[parentQid][pindex];
        const questionIndex = qaArray.findIndex(
          (q) => q.QuestionId === parentQid
        );

        const newOption = {
          OptionId: qdata.question_id,
          OptionText: qdata.question,
          HasCondition: name === "HasCondition" ? value : "",
          ExactDiagnosis: name === "ExactDiagnosis" ? value : "",
        };

        if (questionIndex === -1) {
          qaArray.push({
            QuestionId: parentQid,
            QuestionText: parentqData.question,
            Options: [newOption],
          });
        } else {
          const optionArray = qaArray[questionIndex].Options;
          const optIndex = optionArray.findIndex(
            (opt) => opt.OptionId === qdata.question_id
          );

          if (optIndex === -1) {
            optionArray.push(newOption);
          } else {
            optionArray[optIndex][name] = value;
          }
        }

        return newState;
      });
    }
    const check = () => {
      if (starCheckedQuestion.hasOwnProperty(parentData.question_id)) {
        if (
          starCheckedQuestion[parentData.question_id].hasOwnProperty(pindex)
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    };

    // const updateHDFCQAlist = (payload) => {
    //   const { parentqData, pindex, qdata, name, value } = payload;
    //   const parentQid = parentqData.question_id;

    //   setStarCheckedQuestion((prevState) => {
    //     const updatedState = { ...prevState };

    //     if (!updatedState[parentQid]) {
    //       updatedState[parentQid] = {};
    //     }

    //     const question = updatedState[parentQid];

    //     if (!question[pindex]) {
    //       question[pindex] = [];
    //     }

    //     const qa = question[pindex];

    //     const newObj = {
    //       QuestionId: parentqData.question_id,
    //       QuestionText: parentqData.question,
    //       Options: [HDFCgetAnswerSet(qdata, name, value, parentQid)],
    //     };

    //     let questionKey = HDFCquestionExist(qa, parentQid);

    //     if (questionKey === false) {
    //       qa.push(newObj);
    //     } else {
    //       // const objKey = qa.findIndex((item) => item.QuestionId == parentQid);
    //       const options = qa[questionKey]["Options"];
    //       const optionIndex = options.findIndex(
    //         (item) => item.OptionId == qdata.question_id
    //       );

    //       if (optionIndex === -1) {
    //         options.push(HDFCgetAnswerSet(qdata, name, value, parentQid));
    //       } else {
    //         options[optionIndex][name] = value;
    //       }

    //       // **Dynamically filter out empty options**
    //       updatedState[parentQid][pindex] = qa
    //         .map((question) => ({
    //           ...question,
    //           Options: question.Options.filter((option) => {
    //             const keys = Object.keys(option).filter(
    //               (key) => key !== "OptionId" && key !== "OptionText"
    //             );
    //             return !keys.every((key) => option[key] === "");
    //           }),
    //         }))
    //         .filter((question) => question.Options.length > 0);
    //     }

    //     return updatedState;
    //   });
    // };

    return (
      <>
        {!check() == false && (
          <div
            className="ppv10 my-3 col-md-12 starbox"
            style={{ minWidth: "248px", padding: "0px" }}
          >
            <div
              className="col-md-12 test-form-container"
              style={{ marginRight: "7px" }}
            >
              {["isHypertension", "isDiabetes"].includes(data.question_id) ? (
                ""
              ) : (
                <span
                  className="nfh1 cash"
                  style={{
                    fontWeight: "600",
                    display: data.question === "Yes" ? "none" : "block",
                    margin: "0px",
                  }}
                >
                  {data.question}
                </span>
              )}
              {parentData.question_id === "isHealthDiseases" &&
                data.question_id == "illness" && (
                  <AnswerSetOne
                    pindex={pindex}
                    qdata={data}
                    parentqData={parentData}
                    proposerData={proposerData}
                    starCheckedQuestion={starCheckedQuestion}
                    setStarCheckedQuestion={setStarCheckedQuestion}
                    updateHDFCQAlist={updateHDFCQAlist}
                  />
                )}

              {parentData.question_id === "isHealthDiseases" &&
                data.question_id == "isHypertension" && (
                  <AnswerSetTwo
                    pindex={pindex}
                    qdata={data}
                    parentqData={parentData}
                    proposerData={proposerData}
                    starCheckedQuestion={starCheckedQuestion}
                    setStarCheckedQuestion={setStarCheckedQuestion}
                    updateHDFCQAlist={updateHDFCQAlist}
                  />
                )}

              {parentData.question_id === "isHealthDiseases" &&
                data.question_id == "isDiabetes" && (
                  <AnswerSetTwo
                    pindex={pindex}
                    qdata={data}
                    parentqData={parentData}
                    proposerData={proposerData}
                    starCheckedQuestion={starCheckedQuestion}
                    setStarCheckedQuestion={setStarCheckedQuestion}
                    updateHDFCQAlist={updateHDFCQAlist}
                  />
                )}
            </div>
          </div>
        )}
      </>
    );
  };

  const AnswerSetOne = React.memo(
    ({
      pindex,
      qdata,
      parentqData,
      proposerData,
      starCheckedQuestion,
      updateHDFCQAlist,
    }) => {
      const parentId = parentqData.question_id;

      const matchedOption = starCheckedQuestion?.[parentId]?.[pindex]
        ?.find((item) => item.QuestionId === parentId)
        ?.Options?.find((opt) => opt.OptionId === qdata.question_id);

      const valueFromProps = matchedOption?.ExactDiagnosis || "";

      // ✅ Local mirror only for rendering input, kept in sync with props
      const [localDiagnosis, setLocalDiagnosis] = useState(valueFromProps);

      // ✅ Sync local state with props when starCheckedQuestion updates
      useEffect(() => {
        setLocalDiagnosis(valueFromProps);
      }, [valueFromProps]);

      const handleBlur = () => {
        if (localDiagnosis !== valueFromProps) {
          updateHDFCQAlist({
            name: "ExactDiagnosis",
            value: localDiagnosis,
            pindex,
            qdata,
            parentqData,
          });
        }
      };

      return (
        <Box className="medical-test-form que-one-family show">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Disease Name
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                value={localDiagnosis}
                size="small"
                placeholder="Enter Disease Name"
                className="medical-input"
                onChange={(e) => setLocalDiagnosis(e.target.value)}
                onBlur={handleBlur}
              />
            </Grid>
          </Grid>
        </Box>
      );
    }
  );
  const AnswerSetTwo = React.memo(
    ({
      pindex,
      qdata,
      parentqData,
      proposerData,
      starCheckedQuestion,
      updateHDFCQAlist,
    }) => {
      const options =
        starCheckedQuestion?.[parentqData.question_id]?.[pindex]?.find(
          (item) => item.QuestionId === parentqData.question_id
        )?.Options || [];

      const matchedOption = options.find(
        (opt) => opt.OptionId === qdata.question_id
      );

      const isChecked = matchedOption?.HasCondition === "yes";

      const handleChange = (e) => {
        const checked = e.target.checked;

        updateHDFCQAlist({
          name: "HasCondition",
          value: checked ? "yes" : "no",
          pindex,
          qdata,
          parentqData,
        });
      };

      return (
        <Box className="medical-test-form que-one-family show settwostar">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isChecked}
                    onChange={handleChange}
                    color="primary"
                  />
                }
                label={qdata?.question || "Mark if applicable"}
              />
            </Grid>
          </Grid>
        </Box>
      );
    }
  );

  return loadingData == true && proposerData ? (
    <>
      <Helmet>
        <title>Medical details</title>

        {/* <meta name="description" content="A brief description of your page for SEO." /> */}
        <meta
          name="keywords"
          content="Insurance Plan, Insurance Quotes, buy insurance"
        />
      </Helmet>
      <div className="container">
        <Redirect />
        <h1 className="mainheading">
          We Sell Happyness* <span className="middelheading">We Buy</span>
          <span className="endheading">Your Fear</span>{" "}
        </h1>
        {errordata && (
          <Alert
            variant="filled"
            severity="error"
            style={{ width: "770px" }}
            onClose={() => {
              set_error(false, "");
            }}
          >
            {errorMessage}
          </Alert>
        )}

        <form onSubmit={medicalQsubmit}>
          <div className="row">
            <div className="col-lg-8 medicalform">
              <div className="nextsection">
                <h1 className="Proposalheader">Proposal form (step 2 of 3)</h1>

                <p className="Medicalheaderp">Medical Details</p>
                {/* <div className="row ppv10 my-3"> */}
                <div
                  style={{ display: "flex", flexWrap: "wrap" }}
                  className="col-md-12"
                >
                  {c_id == "hdfc" && plan_id == "Family"
                    ? questionData.map((data, index) => {
                        return (
                          <>
                            <HDFCQuestionAnswer
                              data={parseData(data)}
                              index={index}
                              insuredData={proposerData?.InsuredDetail}
                              HDFCcheckedQuestion={HDFCcheckedQuestion}
                              setHDFCcheckedQuestion={setHDFCcheckedQuestion}
                              medErrors={medErrors}
                              setMedErrors={setMedErrors}
                            />

                            <div className="med-person-div col-md-12">
                              {proposerData?.InsuredDetail.map(
                                (persion, pindex) => {
                                  return (
                                    <>
                                      <HDFCPersion
                                        data={parseData(data)}
                                        persion={persion}
                                        pindex={pindex}
                                        proposerData={
                                          proposerData && proposerData
                                        }
                                        HDFCcheckedQuestion={
                                          HDFCcheckedQuestion
                                        }
                                        setHDFCcheckedQuestion={
                                          setHDFCcheckedQuestion
                                        }
                                      />
                                    </>
                                  );
                                }
                              )}
                            </div>
                          </>
                        );
                      })
                    : c_id == "hdfc" && plan_id == "Individual"
                    ? questionData.map((data, index) => {
                        return (
                          <>
                            <HDFCQuestionAnswerIndividual
                              data={parseData(data)}
                              index={index}
                              insuredData={proposerData?.InsuredDetail}
                              HDFCcheckedQuestion={HDFCcheckedQuestion}
                              setHDFCcheckedQuestion={setHDFCcheckedQuestion}
                              medErrors={medErrors}
                              setMedErrors={setMedErrors}
                            />

                            <div className="med-person-div col-md-12">
                              {proposerData?.InsuredDetail.map(
                                (persion, pindex) => {
                                  return (
                                    <>
                                      <HDFCPersionIndividual
                                        data={parseData(data)}
                                        persion={persion}
                                        pindex={pindex}
                                        proposerData={
                                          proposerData && proposerData
                                        }
                                        HDFCcheckedQuestion={
                                          HDFCcheckedQuestion
                                        }
                                        setHDFCcheckedQuestion={
                                          setHDFCcheckedQuestion
                                        }
                                      />
                                    </>
                                  );
                                }
                              )}
                            </div>
                          </>
                        );
                      })
                    : c_id == "icici"
                    ? questionData.map((data, index) => {
                        return (
                          <>
                            <ICICIQuestionAnswer
                              data={parseData(data)}
                              index={index}
                              insuredData={proposerData?.InsuredDetail}
                              proposerData={proposerData && proposerData}
                              ICICIcheckedQuestion={ICICIcheckedQuestion}
                              setICICICheckedQuestion={setICICICheckedQuestion}
                              medErrors={medErrors}
                              setMedErrors={setMedErrors}
                            />
                            <div className="icici-med-person-div col-md-12">
                              {proposerData.InsuredDetail.map(
                                (persion, pindex) => {
                                  return (
                                    <>
                                      <ICICIPersion
                                        data={parseData(data)}
                                        persion={persion}
                                        pindex={pindex}
                                        proposerData={
                                          proposerData && proposerData
                                        }
                                        ICICIcheckedQuestion={
                                          ICICIcheckedQuestion
                                        }
                                        setICICICheckedQuestion={
                                          setICICICheckedQuestion
                                        }
                                      />
                                    </>
                                  );
                                }
                              )}
                            </div>
                          </>
                        );
                      })
                    : c_id == "reliance"
                    ? questionData.map((data, index) => {
                        return (
                          <>
                            <RelianceQuestionAnswer
                              data={parseData(data)}
                              index={index}
                              insuredData={proposerData?.InsuredDetail}
                              ReliancecheckedQuestion={ReliancecheckedQuestion}
                              setRelianceCheckedQuestion={
                                setRelianceCheckedQuestion
                              }
                            />

                            {proposerData?.InsuredDetail.map(
                              (persion, pindex) => {
                                return (
                                  <>
                                    <ReliancePersion
                                      data={parseData(data)}
                                      persion={persion}
                                      pindex={pindex}
                                      proposerData={
                                        proposerData && proposerData
                                      }
                                      ReliancecheckedQuestion={
                                        ReliancecheckedQuestion
                                      }
                                      setRelianceCheckedQuestion={
                                        setRelianceCheckedQuestion
                                      }
                                    />
                                  </>
                                );
                              }
                            )}
                          </>
                        );
                      })
                    : c_id == "star"
                    ? questionData.map((data, index) => {
                        return (
                          <>
                            <StarQuestionAnswer
                              data={parseData(data)}
                              index={index}
                              insuredData={proposerData?.InsuredDetail}
                              starCheckedQuestion={starCheckedQuestion}
                              setStarCheckedQuestion={setStarCheckedQuestion}
                              medErrors={medErrors}
                              setMedErrors={setMedErrors}
                            />

                            <div className="med-person-div col-md-12">
                              {proposerData?.InsuredDetail.map(
                                (persion, pindex) => {
                                  return (
                                    <>
                                      <StarPersion
                                        data={parseData(data)}
                                        persion={persion}
                                        pindex={pindex}
                                        proposerData={
                                          proposerData && proposerData
                                        }
                                        starCheckedQuestion={
                                          starCheckedQuestion
                                        }
                                        setStarCheckedQuestion={
                                          setStarCheckedQuestion
                                        }
                                      />
                                    </>
                                  );
                                }
                              )}
                            </div>
                          </>
                        );
                      })
                    : questionData.map((data, index) => {
                        return (
                          <>
                            {/* {alert(checkedQuestion)} */}

                            <DigitQuestionAnswer
                              data={parseData(data)}
                              index={index}
                              insuredData={proposerData?.InsuredDetail}
                              proposerData={proposerData && proposerData}
                              setProposerData={setProposerData}
                              setPropo
                              checkedQuestion={checkedQuestion}
                              setCheckedQuestion={setCheckedQuestion}
                              careCheckedQuestion={careCheckedQuestion}
                              setCareCheckedQuestion={setCareCheckedQuestion}
                              medErrors={medErrors}
                              setMedErrors={setMedErrors}
                            />
                            {/* data, insuredData, index, proposerData, checkedQuestion, setCheckedQuestion */}
                            <Persion
                              data={parseData(data)}
                              insuredData={proposerData?.InsuredDetail}
                              index={index}
                              proposerData={proposerData && proposerData}
                              checkedQuestion={checkedQuestion}
                              setCheckedQuestion={setCheckedQuestion}
                              setProposerData={setProposerData}
                              checkedPersion={checkedPersion}
                              setCheckedPersion={setCheckedPersion}
                              careCheckedQuestion={careCheckedQuestion}
                              setCareCheckedQuestion={setCareCheckedQuestion}
                              medErrors={medErrors}
                              setMedErrors={setMedErrors}
                            />
                          </>
                        );
                      })}
                  {/* </div> */}
                </div>
              </div>
              <div></div>
            </div>

            <div className="col-lg-4">
              <Summary
                settingData={settingData}
                set_error={set_error}
                nextPage="kyc"
                addondataList={addonDataList}
                setAddonDataList={setAddonDataList}
                addonsArray={addonArr}
                setAddonArr={setAddonArr}
                planInfo={apiResponse ? apiResponse : ""}
                apiResponse={apiResponse}
                setApiResponse={setApiResponse}
                finalAddonList={finalAddonList}
                setFinalAddonList={setFinalAddonList}
                extData={extData}
                setExtData={setExtData}
                HDFCcheckedQuestion={HDFCcheckedQuestion}
                ICICIcheckedQuestion={ICICIcheckedQuestion}
                starCheckedQuestion={starCheckedQuestion}
                validateFields={validateFields}
                proposerData={proposerData}
              />
            </div>
          </div>
        </form>
      </div>
    </>
  ) : (
    <>
      <Redirect />
      <div className="container">
        <div className="row">
          <div className="col-lg-8 ">
            <div className="medicalsklition_formsklition">
              <div className="headersklition_propsal">
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="skallitonform1"
                />
              </div>
              <div className="medicalfullwidth">
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="medicalfullwidthQustions"
                />
              </div>
              <div className="medicalfullwidth">
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="medicalfullwidthQustions"
                />
              </div>
              <div className="medicalfullwidth">
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="medicalfullwidthQustions"
                />
              </div>
              <div className="medicalfullwidth">
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="medicalfullwidthQustions"
                />
              </div>
              <div className="medicalfullwidth">
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="medicalfullwidthQustions"
                />
              </div>
              <div className="medicalfullwidth">
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="medicalfullwidthQustions"
                />
              </div>
              <div className="medicalfullwidth">
                <Skeleton
                  variant="text"
                  animation="wave"
                  className="medicalfullwidthQustions"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="summerySklition">
              <div className="headerSklition">
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  className="summeryheadtext"
                />
              </div>
              <div className="summerysklitonbody">
                <Skeleton
                  variant="circular"
                  animation="wave"
                  className="summeryAfterFetchimages"
                />
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  className="priceandtanureSummerySkalition"
                />
              </div>
              <div className="sklitionbody2">
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  className="skalitionSummeryText1"
                />
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  className="skalitionSummeryText1"
                />
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  className="skalitionSummeryText1"
                />
              </div>

              <div className="summeryfooterbody">
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  className="skalitionSummeryText3"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MedicalDetails;

const DigitQuestionAnswer = ({
  data,
  index,
  insuredData,
  proposerData,
  checkedQuestion,
  setCheckedQuestion,
  setProposerData,
  careCheckedQuestion,
  setCareCheckedQuestion,
  medErrors,
  setMedErrors,
}) => {
  // const dispatch = useDispatch();

  // const checkedQuestion = useSelector(selectcheckedQuestion);
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const c_id = params.get("c_id");

  const updateCheckedQuestion = (payloadData, insuredData) => {
    let storeData = [...payloadData.checked_question];

    let c_id = payloadData.c_id;

    if (c_id == "care") {
      //  for validation only ------------------------

      let objMain = careCheckedQuestion;

      if (objMain) {
        if (payloadData.isChecked) {
          // objMain?.push(payloadData.val)
          objMain[payloadData.val] = {};
        } else {
          // if(objMain?.includes(payloadData.val)){
          //   let indexVal = objMain?.indexOf(payloadData.val);

          //    objMain?.splice(indexVal ,1);

          // }
          let keyToRemove = payloadData.val;

          if (objMain.hasOwnProperty(keyToRemove)) {
            // delete objMain[data]

            const newObj = Object.fromEntries(
              Object.entries(objMain).filter(([key]) => key != keyToRemove)
            );

            objMain = newObj;
          }
        }
      }

      setCareCheckedQuestion(objMain);

      // -----------------------------------------------------
    }

    if (storeData.includes(payloadData.val)) {
      let index = storeData.indexOf(payloadData.val);
      storeData.splice(index, 1);

      if (c_id == "care") {
        let questionSetCd = payloadData.questionSetCode;
        let updatedInsuredData = insuredData.map((insuredItem) => {
          if (insuredItem.hasOwnProperty("partyQuestionDOList")) {
            let data = insuredItem.partyQuestionDOList;

            let qa = Array.isArray(data)
              ? data
              : data && Object.keys(data).length === 0
              ? []
              : data;

            let tempArray = qa.filter(
              (question) => question.questionSetCd != questionSetCd
            );
            return {
              ...insuredItem,
              partyQuestionDOList: tempArray.length === 0 ? {} : tempArray,
            };
          }

          return insuredItem;
        });

        setProposerData((prevData) => ({
          ...prevData,
          InsuredDetail: updatedInsuredData,
        }));
      }
      // If c_id is "godigit"
      else if (c_id == "godigit") {
        let question_id = payloadData.question_id;
        let updatedInsuredData = insuredData.map((insuredItem) => {
          if (insuredItem.hasOwnProperty("medicalQuestions")) {
            let qa = insuredItem.medicalQuestions;
            let tempArray;

            if (Array.isArray(qa)) {
              tempArray = qa.filter(
                (question) => question.questionCode !== question_id
              );
            } else {
              tempArray = qa;
            }

            return { ...insuredItem, medicalQuestions: tempArray };
          }
          return insuredItem;
        });

        setProposerData((prevData) => ({
          ...prevData,
          InsuredDetail: updatedInsuredData,
        }));
      }
    } else {
      storeData.push(payloadData.val);
    }

    setCheckedQuestion(storeData);
  };

  useEffect(() => {
    if (medErrors.length > 0) {
      const firstErrorElement = document.querySelector(
        `[data-question-id="${medErrors[0]}"]`
      );
      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }, [medErrors]);

  return (
    <>
      <div className="all-que-div col-md-12">
        <div
          className={
            medErrors.includes(data.question_id)
              ? "col-md-12 pmd-all med-error-present care-que"
              : "col-md-12 pmd-all med-error-absent care-que"
          }
        >
          {/*<span className='nfh1 cash'>Q.{data.question}</span>*/}
          <FormControlLabel
            value={index}
            onChange={
              (e) => {
                updateCheckedQuestion(
                  {
                    val: e.target.value,
                    questionSetCode: data.QuestionSetCode,
                    c_id: c_id,
                    question_id: data.question_id,
                    checked_question: checkedQuestion,
                    main_que_id: data.id,
                    isChecked: e.target.checked,
                  },
                  insuredData
                );
              }
              // dispatch(
              //   updatecheckedQuestion({
              //     val: e.target.value,
              //     questionSetCode: data.QuestionSetCode,
              //     c_id: c_id,
              //     question_id: data.question_id,
              //   })
              // )
            }
            // style={{alignItems:"flex-start"}}
            className={
              medErrors.includes(data.question_id)
                ? "label-error"
                : "label-normal"
            }
            control={
              <Checkbox
                className={
                  medErrors.includes(data.question_id)
                    ? "checkbox-error"
                    : "checkbox-normal"
                }
              />
            }
            label={"Q." + data.question}
            checked={checkedQuestion.includes(index.toString())}
          />
        </div>
      </div>
    </>
  );
};

const DigitSubQuestionAnswer = ({
  data,
  qid,
  pid,
  parentData,
  proposerData,
  setProposerData,
  checkedPersion,
  checkedQuestion,
}) => {
  const [objData, setObjData] = useState();
  const [fieldData, setFieldData] = useState("");
  // const checkedPersion = useSelector(selectcheckedPersion);
  // const proposerData = useSelector(selectproposerData);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (proposerData?.InsuredDetail[pid]?.medicalQuestions) {
  //     let valdata = proposerData?.InsuredDetail[pid]?.medicalQuestions;

  //     let val = [valdata];

  //     val.map((item, index) => {
  //       if (item.questionCode == parentData.question_id) {
  //

  //         item.subQuestions.map((value, index) => {
  //           if (value.questionCode == data.question_id) {
  //             setObjData(value);
  //           }
  //         });
  //       }
  //     });
  //   }
  // }, []);

  useEffect(() => {
    if (
      proposerData?.InsuredDetail[pid]?.medicalQuestions &&
      Array.isArray(proposerData?.InsuredDetail[pid]?.medicalQuestions)
    ) {
      let valdata = proposerData?.InsuredDetail[pid]?.medicalQuestions;

      let val = [valdata];

      val.map((item, index) => {
        item.map((info, ind) => {
          if (info.questionCode == parentData?.question_id) {
            // setCheckedQuestion((prevData)=>{

            //   // return(
            //     prevData.push(qid)
            // // )
            // }
            //  )

            // setCheckedQuestion((prevData) => {
            //   const safePrevData = prevData || []; // Ensure it is an array

            //   return [...safePrevData, qid];
            // });

            info?.subQuestions.map((value, index) => {
              if (value.questionCode == data.question_id) {
                setObjData(value);
              }
            });
          }
        });
      });
    }
  }, []);

  const check = () => {
    if (checkedPersion?.hasOwnProperty(qid)) {
      if (checkedPersion[qid].includes(pid)) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  function godigitquestionExist(qa, qid) {
    for (let i = 0; i < qa.length; i++) {
      if (qa[i].questionCode == qid) {
        return true;
        break;
      }
    }
    return false;
  }

  const updateGodigitQAlist = (payloadData) => {
    let storeData = proposerData.InsuredDetail;
    let persionData = storeData[payloadData.pid]; // Get the person data based on pid
    let qdata = payloadData.qdata; // Question data
    let value = payloadData.value; // The answer to the question
    let parentqData = payloadData.parentqData; // Parent question data

    // Ensure the person has a `medicalQuestions` array
    if (!persionData.hasOwnProperty("medicalQuestions")) {
      persionData.medicalQuestions = [];
    }

    let qa = persionData.medicalQuestions;

    // If the parent question already exists in the `medicalQuestions` array
    if (godigitquestionExist(qa, parentqData.question_id)) {
      let key = qa.findIndex(
        (element) => element.questionCode === parentqData.question_id
      );

      let keyone = qa[key].subQuestions.findIndex(
        (element) => element.questionCode === qdata.question_id
      );

      // If the sub-question doesn't exist, push it into the `subQuestions` array
      if (keyone === -1) {
        qa[key].subQuestions.push({
          questionCode: qdata.question_id,
          answerType: "Text_Descript",
          isApplicable: true,
          detailAnswer: value,
          subQuestions: [],
        });
      } else {
        // Otherwise, update the `detailAnswer` for the existing sub-question
        qa[key].subQuestions[keyone].detailAnswer = value;
      }
    } else {
      // If the parent question doesn't exist, add it along with the sub-question
      qa.push({
        questionCode: parentqData.question_id,
        answerType: "BOOLEAN",
        isApplicable: true,
        detailAnswer: "FALSE",
        subQuestions: [
          {
            questionCode: qdata.question_id,
            answerType: "Text_Descript",
            isApplicable: true,
            detailAnswer: value,
            subQuestions: [],
          },
        ],
      });
    }

    // Update the proposerData state
    setProposerData((prevData) => ({
      ...prevData,
      InsuredDetail: prevData.InsuredDetail.map((person, index) => {
        if (index === payloadData.pid) {
          return persionData; // Update the specific person's data
        }
        return person;
      }),
    }));
  };

  // const updateGodigitQAlist = (payloadData) => {
  //   let storeData = proposerData.InsuredDetail || [];
  //   let persionData = storeData[payloadData.pid];
  //   if (!persionData) {
  //     console.error("Invalid person data for pid:", payloadData.pid);
  //     return;
  //   }

  //   let qdata = payloadData.qdata;
  //   let value = payloadData.value;
  //   let parentqData = payloadData.parentqData;

  //   if (!Array.isArray(persionData.medicalQuestions)) {
  //     persionData.medicalQuestions = [];
  //   }

  //   let qa = persionData.medicalQuestions;

  //   if (godigitquestionExist(qa, parentqData.question_id)) {
  //     let key = qa.findIndex(
  //       (element) => element.questionCode === parentqData.question_id
  //     );

  //     let keyone = qa[key].subQuestions.findIndex(
  //       (element) => element.questionCode === qdata.question_id
  //     );

  //     if (keyone === -1) {
  //       qa[key].subQuestions.push({
  //         questionCode: qdata.question_id,
  //         answerType: "Text_Descript",
  //         isApplicable: true,
  //         detailAnswer: value,
  //         subQuestions: [],
  //       });
  //     } else {
  //       qa[key].subQuestions[keyone].detailAnswer = value;
  //     }
  //   } else {
  //     qa.push({
  //       questionCode: parentqData.question_id,
  //       answerType: "BOOLEAN",
  //       isApplicable: true,
  //       detailAnswer: "FALSE",
  //       subQuestions: [
  //         {
  //           questionCode: qdata.question_id,
  //           answerType: "Text_Descript",
  //           isApplicable: true,
  //           detailAnswer: value,
  //           subQuestions: [],
  //         },
  //       ],
  //     });
  //   }

  //   setProposerData((prevData) => {
  //     const updatedInsuredDetail = prevData.InsuredDetail.map((person, index) =>
  //       index === payloadData.pid ? { ...persionData } : person
  //     );
  //     return {
  //       ...prevData,
  //       InsuredDetail: updatedInsuredDetail,
  //     };
  //   });
  // };

  return (
    <>
      <div className="row col-md-12" hidden={check()}>
        <div className="col pmd">
          <span className="nfh1 cash">Q.{data.question}</span>

          <FormGroup>
            <TextField
              id="standard-select-currency-native"
              select
              label=""
              value={fieldData ? fieldData : objData?.detailAnswer}
              SelectProps={{
                native: true,
              }}
              variant="standard"
              onChange={(e) => {
                setFieldData(e.target.value);
                // dispatch(
                //   updateGodigitQAlist({
                //     qid: qid,
                //     pid: pid,
                //     qdata: data,
                //     parentqData: parentData,
                //     value: e.target.value,
                //   })
                // );

                updateGodigitQAlist({
                  qid: qid,
                  pid: pid,
                  qdata: data,
                  parentqData: parentData,
                  value: e.target.value,
                });
              }}
            >
              <option>Select</option>

              {data.answers.map((data) => {
                return (
                  <option value={data.answer_code}>
                    {data.answer_description}
                  </option>
                );
              })}
            </TextField>
          </FormGroup>
        </div>
      </div>
    </>
  );
};

const convertDateFormat = (dateString) => {
  // Split the date string into day, month, and year components
  const parts = dateString.split("-");

  // Ensure that there are three parts (day, month, and year)
  if (parts.length !== 3) {
    throw new Error("Invalid date format");
  }
  const formattedDate = `${parts[1]}-${parts[0]}`;

  return formattedDate;
};

const getCurrentMonthYear = () => {
  const currentDate = dayjs();

  const currentMonthYear = currentDate.format("MM-YYYY");

  return currentMonthYear;
};

const CareSubQuestionAnswer = ({
  data,
  qid,
  pid,
  parentData,
  dobdata,
  proposerData,
  checkedPersion,
  setProposerData,
  checkedQuestion,
  setCareCheckedQuestion,
  careCheckedQuestion,
}) => {
  const monthdata = convertDateFormat(dobdata);

  const currentmonthyear = getCurrentMonthYear();

  const oldqdata = proposerData.InsuredDetail[pid];
  let value = null;
  if (oldqdata.hasOwnProperty("partyQuestionDOList")) {
    let partyQuestionDOList = oldqdata.partyQuestionDOList;

    for (let i = 0; i < partyQuestionDOList.length; i++) {
      if (partyQuestionDOList[i].questionCd == data.question_id) {
        value = partyQuestionDOList[i].response;
      }
    }
  }

  const check = () => {
    if (checkedPersion?.hasOwnProperty(qid)) {
      if (checkedPersion[qid].includes(pid)) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  let yes_no_array = ["pedYesNo", "H001", "H002", "H003", "H004"];

  function questionExist(qa, qid) {
    for (let i = 0; i < qa.length; i++) {
      if (qa[i].questionCd == qid) {
        return true;
      }
    }
    return false;
  }

  function addZeroToMonth(dateString) {
    try {
      let parts = dateString.split("/");

      let month = parseInt(parts[0]);
      let zeroPaddedMonth = month < 10 ? "0" + month : month;

      let formattedDateString = zeroPaddedMonth + "/" + parts[1];
      return formattedDateString;
    } catch (err) {
      return dateString;
    }
  }

  const updateCareQAlist = (payloadData) => {
    const { pid, qdata, value, parentqData } = payloadData;

    // Find the person data by pid
    let persionData = proposerData.InsuredDetail[pid];

    // Ensure 'partyQuestionDOList' exists and is an array
    if (
      !persionData?.hasOwnProperty("partyQuestionDOList") ||
      !Array.isArray(persionData.partyQuestionDOList)
    ) {
      persionData.partyQuestionDOList = [];
    }

    let qa = persionData.partyQuestionDOList;

    let yes_no_array = ["pedYesNo", "H001", "H002", "H003", "H004"];

    if (questionExist(qa, qdata.question_id)) {
      for (let i = 0; i < qa.length; i++) {
        if (qa[i].questionCd === qdata.question_id) {
          qa[i].response =
            qdata.question_id === "OtherSmokeDetails" ||
            qdata.question_id === "otherDiseasesDescription" ||
            yes_no_array.includes(qdata.question_id)
              ? value
              : addZeroToMonth(value);
          break;
        }
      }
    } else {
      if (!questionExist(qa, parentqData.question_id)) {
        qa.push({
          questionSetCd: parentqData.QuestionSetCode,
          questionCd: parentqData.question_id,
          response: "YES",
        });
      }

      if (!yes_no_array.includes(qdata.question_id)) {
        qa.push({
          questionSetCd: qdata.QuestionSetCode,
          questionCd: qdata.question_id,
          response:
            qdata.question_id === "OtherSmokeDetails" ||
            qdata.question_id === "otherDiseasesDescription"
              ? value
              : addZeroToMonth(value),
        });
      }
    }

    setProposerData((prevData) => ({
      ...prevData,
      InsuredDetail: prevData.InsuredDetail.map((person) => {
        if (person.id === pid) {
          return persionData;
        }
        return person;
      }),
    }));
  };

  return (
    <>
      <div className="care-persion-div col-md-12" hidden={check()}>
        {data.question_id == "OtherSmokeDetails" ||
        data.question_id == "otherDiseasesDescription" ? (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="body2" className="medical-label">
                  {data.question}
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  placeholder="Enter the details"
                  className="medical-input"
                  defaultValue={value}
                  onChange={(e) =>
                    updateCareQAlist({
                      qid: qid,
                      pid: pid,
                      qdata: data,
                      parentqData: parentData,
                      value: e.target.value,
                    })
                  }
                />
              </Grid>
            </Grid>
          </>
        ) : yes_no_array.includes(data.question_id) ? (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="body2" className="medical-label">
                  {data.question}
                </Typography>
                <TextField
                  className="medical-input"
                  fullWidth
                  variant="outlined"
                  size="small"
                  id="standard-select-currency-native"
                  select
                  // label={data.question}
                  SelectProps={{
                    native: true,
                  }}
                  onChange={(e) =>
                    updateCareQAlist({
                      qid: qid,
                      pid: pid,
                      qdata: data,
                      parentqData: parentData,
                      value: e.target.value,
                      e,
                    })
                  }
                >
                  <option value="" disabled>
                    Select Option
                  </option>
                  <option value="NO" selected={value == "NO"}>
                    NO
                  </option>
                  <option value="YES" selected={value == "YES"}>
                    YES
                  </option>
                </TextField>
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="body2" className="medical-label">
                  {data.question}
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    views={["year", "month"]} // Enables month & year selection only
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        className: "medical-input",
                      },
                    }}
                    value={value ? dayjs(value, "MM-YYYY") : null}
                    onChange={(e) =>
                      updateCareQAlist({
                        qid: qid,
                        pid: pid,
                        qdata: data,
                        parentqData: parentData,
                        value: getMonthYear(e),
                      })
                    }
                    minDate={dayjs(monthdata, "MM-YYYY")}
                    maxDate={dayjs(currentmonthyear, "MM-YYYY")}
                    format="MM-YYYY"
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </>
        )}
      </div>
    </>
  );
};

const Persion = ({
  data,
  insuredData,
  index,
  proposerData,
  checkedQuestion,
  setCheckedQuestion,
  setProposerData,
  checkedPersion,
  setCheckedPersion,
  careCheckedQuestion,
  setCareCheckedQuestion,
  medErrors,
  setMedErrors,
}) => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const unique_id = params.get("req_id");
  const plan_id = params.get("plan_id");
  const c_id = params.get("c_id");

  const [clickPersion, setClickPersion] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  const updateCheckedPersion = (payloadData) => {
    let storeData = { ...checkedPersion };
    let c_id = payloadData.c_id;

    if (storeData.hasOwnProperty(payloadData.qid)) {
      if (storeData[payloadData.qid].includes(payloadData.pid)) {
        let index = storeData[payloadData.qid].indexOf(payloadData.pid);
        storeData[payloadData.qid].splice(index, 1);

        let persionData = proposerData.InsuredDetail[payloadData.pid];

        if (c_id === "care") {
          let qa = persionData.partyQuestionDOList || [];
          let tempArray = [];
          let questionSetCd = payloadData.questionSetCd;

          if (qa && Object.keys(qa).length > 0) {
            qa.forEach((question) => {
              if (question.questionSetCd !== questionSetCd) {
                tempArray.push(question);
              }
            });
          }

          persionData.partyQuestionDOList = tempArray;
        } else if (c_id === "godigit") {
          let qa = persionData.medicalQuestions || [];
          let tempArray = [];
          let question_id = payloadData.question_id;

          qa.forEach((question) => {
            if (question.questionCode !== question_id) {
              tempArray.push(question);
            }
          });

          persionData.medicalQuestions = tempArray;
        }

        let newInsuredData = proposerData.InsuredDetail.map((person) => {
          if (person.id === payloadData.pid) {
            return persionData;
          }
          return person;
        });

        setProposerData((prevData) => ({
          ...prevData,
          InsuredDetail: newInsuredData,
        }));
      } else {
        storeData[payloadData.qid].push(payloadData.pid);
      }
    } else {
      storeData[payloadData.qid] = [payloadData.pid];
    }

    // for validation checking ------------------------------

    // let mainObj_key = Object.keys(careCheckedQuestion);

    // mainObj_key.forEach((item,index)=>{
    //   if(storeData[item]){

    //     let personObj = storeData[item] == [] ? {} :
    //     { [payloadData.pid]: storeData[item] }

    //     let newQueSet = {
    //       ...careCheckedQuestion,
    //       ...personObj
    //     }

    //   }
    // })

    let newQueSet = {};

    let keys = Object.keys(careCheckedQuestion);

    keys.forEach((item, ind) => {
      if (storeData[item]) {
        newQueSet = {
          ...careCheckedQuestion,
          [item]: storeData[item],
        };
        let data = transformObject(newQueSet);

        setCareCheckedQuestion(data);
      }
    });

    setCheckedPersion(storeData);
  };

  function transformObject(input) {
    const output = {};

    for (const key in input) {
      if (Array.isArray(input[key])) {
        output[key] = {};
        input[key].forEach((item) => {
          output[key][item] = [];
        });
      } else {
        output[key] = input[key];
      }
    }

    return output;
  }

  const handleClick = (pindex) => {
    updateCheckedPersion(
      {
        qid: index,
        pid: pindex,
        question_id: data.question_id,
        questionSetCd: data.QuestionSetCode,
        c_id: c_id,
        qdata: data,
      },
      checkedPersion,
      setCheckedPersion,
      insuredData,
      proposerData
    );
  };

  return (
    <>
      <div
        className="col-md-12 care-wrap-persion"
        hidden={!checkedQuestion.includes(index.toString())}
      >
        {insuredData.map((persion, pindex) => {
          const check = () => {
            if (checkedPersion?.hasOwnProperty(index)) {
              if (checkedPersion[index].includes(pindex)) {
                return "sumboxone";
              } else {
                return "";
              }
            } else {
              return "";
            }
          };

          return (
            <>
              <div className="same-section-med col-md-6 visible-section">
                {/* <div className="scroll"> */}
                <div
                  className={"clickable-box" + check()}
                  onClick={() => handleClick(pindex)}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className={`${
                      check()
                        ? "sumbox all-med-sum col-md-12"
                        : "sumbox all-med-addon"
                    } sumbox-center`}
                  >
                    {/* <span className="proposalname">
                        {proposerData.InsuredDetail[pindex].InsuredName} (
                        {persion.InsuredRelation}){" "}
                      </span> */}
                    <div>
                      <span className={check() ? "para" : "para-unchecked"}>
                        {proposerData?.InsuredDetail[pindex]?.InsuredName}
                        <span
                          className={check() ? "para-relation" : "para-rel"}
                        >
                          ({persion?.InsuredRelation})
                        </span>{" "}
                      </span>
                    </div>
                  </div>
                </div>

                {check() ? (
                  <Box className={`medical-test-form ${visible ? "show" : ""}`}>
                    {data.get_child_question.map((child_data) => {
                      if (c_id == "godigit") {
                        return (
                          <DigitSubQuestionAnswer
                            data={child_data}
                            parentData={data}
                            qid={index}
                            pid={pindex}
                            proposerData={proposerData}
                            setProposerData={setProposerData}
                            checkedPersion={checkedPersion}
                            checkedQuestion={checkedQuestion}
                          />
                        );
                      } else if (c_id == "care") {
                        return (
                          <>
                            <CareSubQuestionAnswer
                              data={child_data}
                              parentData={data}
                              qid={index}
                              pid={pindex}
                              dobdata={persion.dateOfbirth}
                              proposerData={proposerData}
                              setProposerData={setProposerData}
                              checkedPersion={checkedPersion}
                              checkedQuestion={checkedQuestion}
                              careCheckedQuestion={careCheckedQuestion}
                              setCareCheckedQuestion={setCareCheckedQuestion}
                              medErrors={medErrors}
                              setMedErrors={setMedErrors}
                            />
                          </>
                        );
                      } else {
                      }
                    })}
                  </Box>
                ) : (
                  ""
                )}

                {/* </div> */}
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};
